import { StyleSheet } from 'aphrodite'

import headers from './headers'
import form from './form'
import user from './user'

import ColorBlind from './ColorBlind'

export default {
  headers: StyleSheet.create(headers),
  form: StyleSheet.create(form),
  user: StyleSheet.create(user),
  ColorBlind
}



// WEBPACK FOOTER //
// ./src/components/Community/partials/CommunityCreator/style/index.js